import React, { useEffect, useState } from "react";
import { sendAppEvent, timeout } from "../../../../Utils";
import SVG from "react-inlinesvg";
import ThumbsUp from "../../shared/ThumbsUp";
import ThumbsDown from "../../shared/ThumbsDown";

import {
  StyledTUDecoy,
  StyledTUDecoyRight,
  StyledTUDecoyLeft,
  StyledTUDecoyMiddle,
  StyledTUDecoyHalf,
  StyledTUDecoyContainer,
  StyledStars,
} from "./styles";

const ThumbsUpDecoy = ({
  content,
  setItems,
  setKeepers,
  keepers,
  items,
  setAnimating,
  animating,
  hasThumbsedUp,
  setHasThumbsedUp,
  setDecoyContent,
  decoyLeft,
  decoyTop,
  keepersListScrolled,
}) => {
  const [kept, setKept] = useState(false);
  const [shooting, setShooting] = useState(false);

  useEffect(() => {
      handleThumbsUp();

    return function cleanup() {
      if (animating) setAnimating(false);
      setDecoyContent(null);
    };
  }, []);

  const cardKept = async () => {
    setKept("startKeepAnimation");
    await timeout(200);
    setShooting(true);
    await timeout(200);
    setKept("startKeepAnimation thumbsFade");
    await timeout(200);
    setKept("thumbsFade marginsAnimateOut");
    await timeout(200);
  };

  const handleThumbsUp = async () => {
      if (!hasThumbsedUp) setHasThumbsedUp(true);
      await Promise.all([cardKept()]);
      //remove item from list
      const newItems = items.filter((item, i) => {
        return item !== content;
      });
      setItems(newItems);
      setKeepers([content].concat(keepers));
      setKept("repositionKeptCard");
      await timeout(400);
      setKept("repositionKeptCard closeIt");
      await timeout(600);
      sendAppEvent("Brainstorm - Kept Card");
      setDecoyContent(null);
      setAnimating(false);
  };

  const isKept = true;
  const keptClassName = kept ? kept : "";

  return (
    <StyledTUDecoyContainer
      key={content}
      className={keptClassName}
      top={decoyTop}
      left={decoyLeft}
      smaller={keepersListScrolled}
      contentLength = {content.length}
    >
        <StyledStars className={shooting && "shooting"} isKept={isKept}>
          <SVG src="/assets/brainstorm/star.svg" />
          <SVG src="/assets/brainstorm/star.svg" />
          <SVG src="/assets/brainstorm/star.svg" />
        </StyledStars>
      <StyledTUDecoyHalf
        side={"right"}
        kept={isKept}
      >
        <StyledTUDecoy side={"right"} kept={isKept}>
          <StyledTUDecoyRight kept={isKept}>
            <ThumbsUp
              color={isKept ? "var(--primary-cta)" : "var(--icon-button-fill)"}
              opacity={isKept ? "1" : "var(--icon-button-fill)"}
            />
          </StyledTUDecoyRight>
          <StyledTUDecoyLeft>
            <ThumbsDown />
          </StyledTUDecoyLeft>
          <StyledTUDecoyMiddle length={content.length}>
            <span>{content}</span>
          </StyledTUDecoyMiddle>
        </StyledTUDecoy>
      </StyledTUDecoyHalf>
    </StyledTUDecoyContainer>
  );
};

export default ThumbsUpDecoy;
